import React, { useEffect, useState } from "react"
import * as styles from "./SectionHeroEvent.module.scss"
import { Helmet } from "react-helmet"
import { useLocation } from "@reach/router"

import { useBusinessQuery } from "../../hooks/layout/useBusinessSchema"
import { GatsbyImage } from "gatsby-plugin-image"

const SectionHeroEvent = ({ data, onCtaClick }) => {
  const {
    title,
    heroImage,
    logo1,
    logo2,
    tag,
    para1,
    para2,
    para3,
    backgroundColor,
    eventButton,
    eventButton2,
  } = data

  const [showMeetingModal, setShowMeetingModal] = useState(false)

  const businessData = useBusinessQuery()

  const {
    eventTitle,
    locationName,
    streetAddress,
    addressLocality,
    addressRegion,
    addressCountry,
    eventDescription,
    organizerName,
    eventPerformer,
    image,
  } = businessData

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowMeetingModal(false)
    }, 5000)

    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    if (showMeetingModal) {
      const script = document.createElement("script")
      script.src =
        "https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
      script.async = true
      document.body.appendChild(script)
    }
  }, [showMeetingModal])

  const handleMeetingClick = () => {
    setShowMeetingModal(true)
  }

  const closeMeetingModal = () => {
    setShowMeetingModal(false)
  }

  const EventSchemaDynamic = {
    "@context": "https://schema.org",
    "@type": "Event",
    name: eventTitle,
    startDate: "2025-05-20T11:00+04:00",
    endDate: "2025-05-22T17:30+04:00",
    eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
    eventStatus: "https://schema.org/EventScheduled",
    location: {
      "@type": "Place",
      name: locationName,
      address: {
        "@type": "PostalAddress",
        streetAddress: streetAddress,
        addressLocality: addressLocality,
        postalCode: "9292",
        addressRegion: addressRegion,
        addressCountry: addressCountry,
      },
    },

    image: image?.map(img => img?.file?.url) || [],
    description: eventDescription,

    performer: {
      "@type": "PerformingGroup",
      name: eventPerformer,
    },
    organizer: {
      "@type": "Organization",
      name: organizerName,
      url: "https://www.terrapinn.com/exhibition/seamless-middle-east/",
    },
  }

  const location =
    typeof window !== "undefined" ? useLocation() : { pathname: "" }
  const isVirtualConsultPage = location.pathname === "/virtual-consult/"

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(EventSchemaDynamic)}
        </script>
      </Helmet>
      <section style={{ backgroundColor: backgroundColor }}>
        <div className={`container ${styles.container}`}>
          <div className={styles.col1}>
            <h1 className={`global-spacing-bottom ${styles.title}`}>{title}</h1>
            <div className={`global-spacing-bottom ${styles.tag}`}> {tag} </div>

            <div className={`global-spacing-bottom ${styles.logoContainer}`}>
              <div>
                {logo2 && (
                  <GatsbyImage
                    image={logo2.gatsbyImageData}
                    alt={logo2.title}
                    loading="eager"
                    fetchPriority="high"
                    className={`${styles.logo2}`}
                  />
                )}
              </div>
            </div>

            <div className={styles.para1}>{para1}</div>
            <div className={styles.para2}>{para2}</div>
            <div className={`global-spacing-bottom ${styles.para3}`}>
              {para3}
            </div>
            <div className={`global-spacing-bottom ${styles.btn}`}>
              <button
                onClick={handleMeetingClick}
                aria-label="Schedule a meeting"
                className={`primaryFilledTwo ${styles.meetingButton}`}
              >
                {eventButton}
              </button>
              {showMeetingModal && (
                <div className={styles.modalOverlay}>
                  <div className={styles.modalContent}>
                    <button
                      className={styles.closeButton}
                      onClick={closeMeetingModal}
                    >
                      ✖
                    </button>
                    {isVirtualConsultPage ? (
                      <div
                        className="meetings-iframe-container"
                        data-src="https://meetings.hubspot.com/deepti-mishra/virtual-meeting?embed=true"
                      ></div>
                    ) : (
                      <div
                        className="meetings-iframe-container"
                        data-src="https://meetings.hubspot.com/deepti-mishra?embed=true"
                      ></div>
                    )}
                  </div>
                </div>
              )}
              {eventButton2 && (
                <button onClick={onCtaClick} className="onPrimaryOutline">
                  {eventButton2}
                </button>
              )}
            </div>
          </div>

          <GatsbyImage
            image={heroImage.gatsbyImageData}
            alt={heroImage.title}
            loading="eager"
            fetchPriority="high"
            layout="constrained"
            placeholder="dominantColor"
            className={`${styles.heroImage}`}
          />
        </div>
      </section>
    </>
  )
}

export default SectionHeroEvent
